import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { FoerchGsmLocalStorageService } from './foerch-gsm-local-storage.service';

export const canActivate: CanActivateFn = () => {
  const localStorageService = inject(FoerchGsmLocalStorageService);
  const router = inject(Router);

  const userId: string = localStorageService.getUserUnitId();
  const token: string = localStorageService.getAccessToken();

  if (!userId || !token) {
    router.navigateByUrl('/login').then(() => {});
  }

  return of(token !== null && userId !== null);
};
